import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Training = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Training</Paragraph>
        <Text className='BaseText2'>In iMoAge we made a Business Analysis & Process Management course in which we were able to learn how to analyze businesses from a process view which allows us to further develop the skill needed to create solutions to our current business problems.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-2.png'/>
          <p>Img 2. Certificate of Business Analysis and Process Management </p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Training;
